import { HoldReasonsResponse } from './holdApiTypes';

// eslint-disable-next-line import/prefer-default-export
export const mockGetHoldReasons: HoldReasonsResponse = {
  reasons: ['stock issue', 'product banned', 'pricing issue', 'restriction'],
};
